import React,{useState,useRef, useEffect} from 'react'
import { useSelector,useDispatch } from 'react-redux'
import { TbTrashX } from "react-icons/tb";
import { BiCloudUpload } from "react-icons/bi";
import { useFormik } from 'formik'
import * as Yup from "yup"
import { handleApi } from '../../utils/authentication'
import { toast } from 'react-toastify'
import { UPDATE_USER_DATA } from '../../redux/features/user/userSlice'
import { EditProfileImage } from '../../components/superadmin';
import user_placeholder from "../../assests/user_default.png"
import Select from "react-select"
import {customStyles} from "../../utils/select_style"

const SuperAdminEditProfile = () => {
    const [loading,setLoading]=useState(false)
    const [loading1,setLoading1]=useState(false)
    const profileImageRef = useRef(null);
    const user=useSelector((state)=>state?.user)
    const [imageUri,setImageUri]=useState('')
    const [show,setShow]=useState(false)
    const [file,setFile]=useState('')
    const dispatch=useDispatch()
    const roles=[
      {value:1,label:"Admin"},
      // {value:2,label:"Owner"},
      {value:3,label:"Member"},
      // {value:4,label:"Viewer"}
  ]
   
    const handleEditProfile=async ()=>{
      try{
        setLoading(true)
        let method = "POST"
        let headers = {}
        let formData = new FormData()
     
        formData.append('super_admin_user_id', user?.super_admin_user_id)
        formData.append('email',formik_profile?.values?.email)
        formData.append('first_name',formik_profile?.values?.first_name)
        formData.append('last_name', formik_profile?.values?.last_name)
     

          
        
        if (imageUri && file) {
          let response = await fetch(imageUri);
       //   console.log(response)
          let image_file = await response.blob();
          formData.append('profile_image', image_file, file?.name);
        }

        let result = await handleApi('edit_super_admin_user', method, headers, formData)
        if(result?.success)
        {
          toast.success(result?.data?.message ? result?.data?.message : "User details updated successfully", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          })
          dispatch(UPDATE_USER_DATA({
            first_name:result?.data?.user_info?.first_name,
            last_name:result?.data?.user_info?.last_name,
            profile_image:result?.data?.user_info?.profile_image }))
          setImageUri(result?.data?.user_info?.profile_image)


        }
        else{
          toast.error(result?.error?.error_message ? result?.error?.error_message : "Failed to update user details", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          })

        }


      }
      catch(e)
      {
        console.log(e)
        toast.error(e?.message, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        })
      }
      finally{
        setLoading(false)
      }

    }
   
    const handleResetPassword=async ()=>{
      try{
        setLoading1(true)
        let method = "POST"
        let headers = {}
        let formData = new FormData()
        formData.append('user_id', user?.super_admin_user_id)
        // formData.append('first_name', formik.values.first_name)
        // formData.append('last_name', formik.values.last_name)
        // formData.append('email',formik?.values?.email)
        formData.append('old_password',formik?.values?.old_password)
        formData.append('new_password', formik?.values?.new_password)
        let result = await handleApi('handle_reset_password', method, headers, formData)
        if(result?.success)
        {
          toast.success(result?.data?.message ? result?.data?.message : "Password updated successfully", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          })


        }
        else{
          toast.error(result?.error?.error_message ? result?.error?.error_message : "Failed to update user password", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          })

        }


      }
      catch(e)
      {
        console.log(e)
        toast.error(e?.message, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        })
      }
      finally{
        setLoading1(false)
      }
    }

 const validationSchema = Yup.object({
      // first_name: Yup.string().required('First Name is required'),
      // last_name: Yup.string().required('Last Name is required'),
      // email: Yup.string().email('Invalid email format').required('Email is required'),
      old_password: Yup.string().required("Old Password is required"),
      new_password: Yup.string().min(8, 'Password must be at least 8 characters long').required(" Password is required"),
    
      confirm_password: Yup.string()
      .oneOf([Yup.ref('new_password'), null], 'Password does not match')
      .when('new_password', (new_password, schema) =>
        new_password ? schema.required('Confirm Password is required') : schema
      ),
    });

  const formik = useFormik({
        initialValues: {
    
        old_password:'',
        new_password:'',
        confirm_password:''
    
        },
        validationSchema: validationSchema,
        onSubmit: (values) => {
         
          handleResetPassword()
    
        },
      });
      const validationSchema_profile = Yup.object({
        first_name: Yup.string().required('First Name is required').matches(/^[A-Za-z]+$/, 'Only letters are allowed'),
        last_name: Yup.string().required('Last Name is required').matches(/^[A-Za-z]+$/, 'Only letters are allowed'),
        email: Yup.string().email('Invalid email format').required('Email is required'),
      
     
      });
      
  const formik_profile= useFormik({
    initialValues: {
    first_name: user?.first_name,
    last_name:user?.last_name,
    email:user?.email,

  
  },
    validationSchema: validationSchema_profile,
    onSubmit: (values) => {
      
     
      handleEditProfile()

    },
  });

  const handleDeleteImage = () => {
    if (imageUri) {
      setImageUri('')
    }

  }
  //reads the image and opens the modal by setting setShow-> true
  const handleImageUpload = (event) => {
    const file = event.target.files[0];
  
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setImageUri(reader.result);
        setShow(true) // Set the image URI in state
      };
      reader.readAsDataURL(file); // Read the file as a data URL
      setFile(file)
    }
     event.target.value=''
  }
  useEffect(()=>{

    setImageUri(user?.profile_image)

  },[])

  return (
    <div className='' >
        <form  onSubmit={formik_profile.handleSubmit}>
          <div className='card profile_card'>
        <EditProfileImage show={show} setShow={setShow} uri={imageUri} setImageUri={setImageUri} aspect_ratio={1} />
          <div>
            <h5 className='pb-0'>Main Info</h5>
          </div>
          {/* edit profile image */}
           
          <div className='row border-1 border-bottom pb-4'>
              <div className='col-xl-2 d-flex justify-content-center justify-content-xl-start  '>
                <img
                  src={imageUri ? imageUri :user_placeholder}
                  alt="Profile"
                />
                <input
                  ref={profileImageRef}
                  type="file"
                  id="profile_image"
                  className='d-none'
                  accept="image/*"
                  onChange={handleImageUpload}
                 
                />
              </div>
              <div className=' col-xl-6 row d-flex align-items-end  '>
              <div className='col-12 col-md-12 col-lg-6 mb-2'>
                <button type="button" disabled={imageUri ? false : true} className={`w-100 ${!imageUri && "disable_btn" } btn btn-outline-custom btn-outline-primary  rounded-pill d-flex  justify-content-center align-items-center gap-1`} onClick={handleDeleteImage} ><TbTrashX /> Delete Image</button>
              </div>
              <div className='col-12 col-md-12 col-lg-6  mb-2 '>
                <button type="button" onClick={() => {
                  profileImageRef.current.click();
                }} className='w-100 py-2 gap-1 btn btn-primary rounded-pill d-flex   justify-content-center  align-items-center  '> <BiCloudUpload /> Upload New Image</button>
              </div>



            </div>
     
            </div>

          <div className="mb-1 row">
            <label htmlFor="first_name" className="col-lg-2  col-form-label">Firstname</label>
            <div className="col-lg-6">
              <input type="text" className="form-control"
               id="first_name"
               placeholder='Firstname'
               onChange={formik_profile.handleChange}
               onBlur={formik_profile.handleBlur}
               value={formik_profile.values.first_name}
               
               />
                 {formik_profile.touched.first_name && formik_profile.errors.first_name ? (
                  <div className='text-danger text-start small'>{formik_profile.errors.first_name}</div>
                ) : null}
            </div>
          </div>
          <div className="mb-1 row">
            <label htmlFor="last_name" className="col-lg-2  col-form-label">Lastname</label>
            <div className="col-lg-6">
              <input type="text" className="form-control"
               id="last_name"
                placeholder='Lastname'
                onChange={formik_profile.handleChange}
                onBlur={formik_profile.handleBlur}
                value={formik_profile.values.last_name}
                
                />
                   {formik_profile.touched.last_name && formik_profile.errors.last_name ? (
                  <div className='text-danger text-start small'>{formik_profile.errors.last_name}</div>
                ) : null}
            </div>
          </div>
          <div className="mb-1 row">
            <label htmlFor="email" className="col-lg-2  col-form-label">Email</label>
            <div className="col-lg-6">
              <input type="email" className="form-control"
               id="email"
                placeholder='Email' 
                onChange={formik_profile.handleChange}
                onBlur={formik_profile.handleBlur}
                value={formik_profile.values.email}
                 disabled
                />
                   {formik_profile.touched.email && formik_profile.errors.email ? (
                  <div className='text-danger text-start small'>{formik_profile.errors.email}</div>
                ) : null}
            </div>
          </div>
   
          <div className="mb-1 row mt-2">
            <div className='col-lg-8 d-flex justify-content-end'>
              {!loading ?
                <button type='submit' className='btn btn-primary rounded-pill px-5'>Update</button> :
                <button type='button' className='btn btn-primary rounded-pill px-5' disabled>processing...</button>}

            </div>
          </div>
          </div>
           
      
 
        </form>

        
        {/* reset password */}
         {/* <form className='card profile_card px-3 my-3' onSubmit={formik.handleSubmit}>
          <div>
            <h5 className='pb-0'>Reset Password</h5>
          </div>
          <div className="mb-1 row">
            <label htmlFor="old_password" className="col-lg-2  col-form-label">Old Password</label>
            <div className="col-lg-6">
              <input type="password" className="form-control"
               id="old_password"
               placeholder='Password'
               onChange={formik.handleChange}
               onBlur={formik.handleBlur}
               value={formik.values.old_password}
               
               />
                  {formik.touched.old_password && formik.errors.old_password ? (
                  <div className='text-danger text-start small'>{formik.errors.old_password}</div>
                ) : null}
            </div>
          </div>
          <div className="mb-1 row">
            <label htmlFor="new_password" className="col-lg-2  col-form-label">New Password</label>
            <div className="col-lg-6">
              <input type="password" className="form-control"
               id="new_password"
                placeholder='New Password'
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.new_password}
                
                
                />
                   {formik.touched.new_password && formik.errors.new_password ? (
                  <div className='text-danger text-start small'>{formik.errors.new_password}</div>
                ) : null}
            </div>
          </div>
          <div className="mb-1 row">
            <label htmlFor="confirm_password" className="col-lg-2  col-form-label">Confirm Password</label>
            <div className="col-lg-6">
              <input type="pssword" className="form-control"
               id="confirm_password"
               placeholder='Confirm Password' 
             
               onChange={formik.handleChange}
               onBlur={formik.handleBlur}
               value={formik.values.confirm_password}
                />
                   {formik.touched.confirm_password && formik.errors.confirm_password ? (
                  <div className='text-danger text-start small'>{formik.errors.confirm_password}</div>
                ) : null}
            </div>
          </div>
          <div className="mb-1 row mt-2">
            <div className='col-lg-8 d-flex justify-content-end'>
              {!loading1 ?
                <button type='submit' className='btn btn-primary rounded-pill px-5'>Update</button> :
                <button type='button' className='btn btn-primary rounded-pill px-5' disabled>processing...</button>}

            </div>
          </div>
        </form>  */}
    </div>
  )
}

export default SuperAdminEditProfile